import styled from 'styled-components';

export const GetBadgeWrap = styled.div`
    width: 100%;
    background: #FFFFFF;
    padding: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 30px 20px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;
    @media screen and (max-width:575px) {
      padding:20px;   
       }
`;

export const GetBadgeBox = styled.div`
    width: calc(50% - 20px);
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 16px 20px;

    @media screen and (max-width:575px) {
        width:100%;   
    }
    &:last-child{
        width: 100%;
        flex-direction: row;
        
        @media screen and (max-width:991px) {
           max-width:inherit;
           flex-wrap: wrap;
        }

        @media screen and (max-width:575px) {
              flex-direction: column;
         } 
    }  
`;

export const GetBadgeTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-weight: 600;
    font-family: 'Jost', sans-serif;
    line-height: 44px;
    margin-bottom: 10px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 20px;
    }
`;

export const GetBadgeCodeWrite = styled.div`
    width: 100%;
    max-width: 240px;
    padding: 5px;

    &.mini-badge-code-group{
        padding: 0px;
    }
`;

export const GetBadgeTop = styled.div`
  .minbug-ifame{
      @media screen and (max-width:991px){
          height: 75px !important;
      }

  }
`;

export const GetBadgeCodeBorder = styled.div`
    width: 100%;
    border: 2px solid #7d7c7c;
    padding: 8px;
    
    &.mini-badge-wrap{
        border: 1px solid #8d8d8d;
        padding: 0px;
        border-radius: 10px;
        overflow: hidden;
    }
`;

export const GetBadgeCodeBody = styled.div`
    width:100%;
    background: #e49217;
    padding: 15px;

    &.orange{
        background: #e49217;
    }
    
    &.green{
        background: #34A853;
    }
    
    &.gray{
        background: #BABABA;
    }
    
    &.blue{
        background: #33A7AE;
    }

`;

export const GetBadgeCodeTitleSmall = styled.h3`
    color: #fff;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
`;

export const GetBadgeCodeLogo = styled.div`
    max-width: 90px;
    margin: 10px auto;

    &.mini-badge-logo{
        max-width: 180px;
    }

    &.star-badge-image{
        max-width: 180px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const GetBadgeCodeTitle = styled.h2`
    color: #fff;
    font-size: 24px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    text-align: center;


    @media screen and (max-width:767px){
        font-size: 22px;
        line-height: 28px;
    }
    
`;

export const GetBadgeCodeFooter = styled.div`
    background: #fff;
    color: #e49217;
    font-size: 16px;
    text-align: center;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 20px;
    margin: 10px auto 0;


    &.orange-text{
         color: #e49217;
    }
    &.green-text{
         color: #34A853;
    }
    
    &.gray-text{
         color: #BABABA;
    }
    
    &.blue-text{
         color: #33A7AE;
    }
`;

export const GetBadgeCodeSubTitle = styled.h3`
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 20px;
    margin: 50px auto;

    &.mini-badge-sub-title{
        margin: 0px auto 10px;
    }

    &.star-badge-title{
       margin: 0px auto 30px;
    }
`;

export const GetBadgeCodeSubTitleStrong = styled.strong`
    color: #fff;
    font-size: 18px;
    text-align: center;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 22px;
    display: block;
    @media screen and (max-width:767px){
        font-size: 16px;
    }
`;

export const GetBadgeCode = styled.div`
    width: 100%;
    max-width: 892px;
    background: #F2F2F2;
    padding: 30px;  
    border-radius: 20px;
    margin-top: 16px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width:991px){
        border-radius: 15px;
    }

    @media screen and (max-width:767px){
        font-size: 16px;
        line-height: 24px;
    }
    
    &.get-a-badge-code {
        margin-top: 50px;
        word-wrap: break-word;

        @media screen and (max-width:991px) {
            word-wrap: break-word;
            padding:20px;
            margin-top: 20px;
        }  
    }

    &.get-badge-code-wrap{
        margin-top: 0px;
         word-wrap: break-word;
         
        @media screen and (max-width:991px) {
            word-wrap: break-word;
            padding:20px;
        }  
    }

`;